import type { StepProgress } from './stepperStyles';

/**
 * The first cleared step whose data no longer matches what it was when the CM advanced past it, or
 * -1 if none. Steps at or after `clearedThrough` were never cleared, so there's nothing to compare.
 */
export function findFirstEditedStep({
  clearedSignatures,
  clearedThrough,
  signatures,
}: {
  clearedSignatures: Array<string | undefined>;
  clearedThrough: number;
  signatures: Array<string>;
}) {
  for (let step = 0; step < clearedThrough; step += 1) {
    if (clearedSignatures[step] !== signatures[step]) {
      return step;
    }
  }

  return -1;
}

/** Cleared steps are done, the furthest step reached is the latest, and everything after it is locked. */
export function getStepProgress({
  clearedThrough,
  hasSucceeded,
  step,
}: {
  clearedThrough: number;
  hasSucceeded: boolean;
  step: number;
}): StepProgress {
  if (hasSucceeded || step < clearedThrough) {
    return 'done';
  }

  return step === clearedThrough ? 'latest' : 'locked';
}

/**
 * Going back is always allowed; going forward only up to the furthest cleared step, since anything past it
 * would skip a step's own Next validation.
 */
export function canGoToStep({
  activeStep,
  clearedThrough,
  step,
}: {
  activeStep: number;
  clearedThrough: number;
  step: number;
}) {
  return step !== activeStep && (step < activeStep || step <= clearedThrough);
}
